import { SyntheticEvent, useState } from 'react';

import { Image, ImageProps } from '../Image';
import { DecorationImageElement } from './style';

export interface EventTargetImage extends EventTarget {
    src?: string;
    currentSrc?: string;
}

export interface DecorationImageProps extends ImageProps {
    children?: React.ReactNode;
    showOverlay?: boolean;
}

const defaultProps = {
    sizes: '100vw',
    loaderDelay: 0,
};

export const DecorationImage: React.FC<DecorationImageProps> = (props) => {
    const { src, srcSet, sizes, children, onError, onLoad, ...other } = props;
    const [imageSrc, setImageSrc] = useState<string>('');

    const handleImageLoad = (event: SyntheticEvent<HTMLElement>) => {
        if (onLoad) {
            onLoad(event);
        }

        setImageSrcState(event.target as EventTargetImage);
    };

    const setImageSrcState = ({ currentSrc, src: eventSrc = '' }: EventTargetImage) => {
        const newImageSrc = currentSrc || eventSrc;
        setImageSrc(newImageSrc);
    };

    const DecorationImageProps = {
        ...props,
        imageSrc,
        ...other,
    };
    const imageProps = {
        src,
        srcSet,
        onError,
        sizes,
        hidden: true,
        onLoad: handleImageLoad,
    };

    return (
        <DecorationImageElement {...DecorationImageProps}>
            <Image {...imageProps} />
            {children}
        </DecorationImageElement>
    );
};

DecorationImage.defaultProps = defaultProps;
